import { render, staticRenderFns } from "./CancellationPolicy.vue?vue&type=template&id=c69aba8e&scoped=true"
import script from "./CancellationPolicy.vue?vue&type=script&lang=js"
export * from "./CancellationPolicy.vue?vue&type=script&lang=js"
import style0 from "./CancellationPolicy.vue?vue&type=style&index=0&id=c69aba8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69aba8e",
  null
  
)

export default component.exports